import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ButtonComponent } from '@modules/components/button/button.component';
import { OpenFilterDirective } from '@modules/filter/services/open-filter.directive';
import { CompanyCard } from '@type/company.type';
import { LogAdminFieldsService } from '../../services/log-admin-fields/log-admin-fields.service';

@Component({
  selector: 'app-log-header',
  imports: [MatToolbarModule, MatIconModule, ButtonComponent, OpenFilterDirective, MatTabsModule, MatFormFieldModule, MatSelectModule],
  templateUrl: './log-header.component.html',
  styleUrl: './log-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogHeaderComponent {
  filterOptionsService = inject(LogAdminFieldsService);

  activeTab = input<number>(0);
  companiesList = input<CompanyCard[]>([]);
  selectedCompanyId = input<number | null>(null);

  tabChanged = output<number>();
  companyChanged = output<number>();
}
